import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PushToggle } from "@/lib/push";
import { usePersistedState } from "@/lib/usePersistedState";
import SvincolatiPanel from "@/pages/Svincolati";
import { TrasferimentiPanel } from "./mercato/TrasferimentiPanel";
import { VetrinaPanel } from "./mercato/VetrinaPanel";

export default function Mercato() {
    const { user } = useAuth();
    const [searchParams] = useSearchParams();
    // Tab attiva persistita: tornando indietro da una scheda giocatore si resta
    // sulla stessa sezione (Trasferimenti / Vetrina / Svincolati), non si torna al default.
    const [section, setSection] = usePersistedState("mercato.section", "trasferimenti");

    // Deep-link da scheda giocatore: ?section=vetrina apre direttamente la Vetrina.
    useEffect(() => {
        const s = searchParams.get("section");
        if (s && ["trasferimenti", "vetrina", "svincolati"].includes(s)) {
            setSection(s);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="mercato-page">
            <div className="op-label" style={{ color: "rgb(var(--tc-ff7a1a))" }}>// TRANSFER MARKET</div>
            <h1 className="op-heading text-5xl sm:text-6xl mt-3">
                <span className="op-gradient-text">MERCATO</span>
            </h1>
            <p className="text-t8f95a3 text-sm mt-3 max-w-2xl">
                Trasferimenti tra squadre e aste a busta chiusa per gli svincolati.
            </p>

            {user && user.team_id && (
                <div className="mt-5">
                    <PushToggle />
                </div>
            )}

            {/* Section switcher */}
            <div className="flex gap-1 mt-8 border-b border-t22252a" data-testid="mercato-section-tabs">
                <SectionTab active={section === "trasferimenti"} onClick={() => setSection("trasferimenti")} testId="section-trasferimenti" label="Trasferimenti" />
                <SectionTab active={section === "vetrina"} onClick={() => setSection("vetrina")} testId="section-vetrina" label="Vetrina" accent="rgb(var(--tc-7ce38b))" />
                <SectionTab active={section === "svincolati"} onClick={() => setSection("svincolati")} testId="section-svincolati" label="Svincolati" accent="rgb(var(--tc-ff7a1a))" />
            </div>

            {section === "trasferimenti" && <TrasferimentiPanel user={user} />}
            {section === "vetrina" && <VetrinaPanel user={user} />}
            {section === "svincolati" && <SvincolatiPanel embedded />}
        </div>
    );
}

function SectionTab({ active, onClick, label, testId, accent = "rgb(var(--tc-2bb6ff))" }) {
    return (
        <button
            onClick={onClick}
            className={`op-heading text-base sm:text-lg px-4 py-3 border-b-2 transition-colors duration-150 ${
                active ? "text-tffffff" : "text-t8f95a3 hover:text-tffffff"
            }`}
            style={{ borderBottomColor: active ? accent : "transparent" }}
            data-testid={testId}
        >
            {label}
        </button>
    );
}

